import * as React from 'react'
import { Row, Message } from 'rsuite'
import SaveButton from '../components/buttons/saveButton/SaveButton'
import EditButton from '../components/buttons/editButton/EditButton'
import CancelButton from '../components/buttons/cancelButton/CancelButton'
import PrintButton from '../components/buttons/printButton/printButton'
import DownloadButton from '../components/buttons/downloadButton/downloadButton'
import SearchButton from '../components/buttons/searchButton/SearchButton'
import PreviewButton from '../components/buttons/previewButton/PreviewButton'

export default function ButtonPanelWidget(props) {
  const {
    buttonText,
    onSave,
    onPrint,
    onCancel,
    onEdit,
    onPreview,
    isDisabled,
    isEdit,
    isError,
    errorMsg,
  } = props

  return (
    <>
      {isEdit ? (
        <div>
          {buttonText?.errorMessage && isError && (
            <Row style={{ marginBottom: 10 }}>
              <Message showIcon type="error" description={errorMsg || buttonText.errorMessage} />
            </Row>
          )}

          {buttonText?.printButtonName && (
            <>
              <PrintButton disabled={isDisabled} onClick={onPrint}>
                {buttonText.printButtonName || ''}
              </PrintButton>
            </>
          )}

          {buttonText?.downloadButtonName && (
            <>
              <DownloadButton disabled={isDisabled} onClick={onPrint}>
                {buttonText.downloadButtonName || ''}
              </DownloadButton>
            </>
          )}

          {buttonText?.searchButtonName && (
            <SearchButton disabled={isDisabled} onClick={onSave}>
              {buttonText.searchButtonName || ''}
            </SearchButton>
          )}

          {buttonText?.saveButtonName && (
            <SaveButton disabled={isDisabled} onClick={onSave}>
              {buttonText.saveButtonName || ''}
            </SaveButton>
          )}

          {buttonText?.previewButtonName && (
            <PreviewButton disabled={isDisabled} onClick={onPreview}>
              {buttonText.previewButtonName || ''}
            </PreviewButton>
          )}

          {buttonText?.cancelButtonName && (
            <>
              <CancelButton onClick={onCancel}>{buttonText.cancelButtonName || ''}</CancelButton>
            </>
          )}
        </div>
      ) : (
        <EditButton onClick={onEdit}>{`แก้ไข${buttonText || ''}`}</EditButton>
      )}
    </>
  )
}
